"use client";

import LoginHandler from "@repo/next-shared/components/login-handler";

export default function Login() {
  return <LoginHandler />;
}
